import { useIsMutating } from '@tanstack/react-query';
import { Backdrop, Typography, Stack } from '@mui/material';
import LogoLoader from '../../components/ui/LogoLoader';

/** Full-screen logo loader shown while a save/edit/delete request is in flight. */
export function SavingOverlay({ open, label = 'Saving…' }: { open: boolean; label?: string }) {
  return (
    <Backdrop open={open} sx={{ zIndex: 1500, color: '#fff', bgcolor: 'rgba(15, 17, 21, 0.45)', backdropFilter: 'blur(2px)' }}>
      <Stack spacing={1.5} alignItems="center" sx={{ p: 3, bgcolor: 'background.paper', color: 'text.primary', boxShadow: 6 }}>
        <LogoLoader size={72} />
        <Typography variant="body2" sx={{ fontWeight: 700 }}>{label}</Typography>
      </Stack>
    </Backdrop>
  );
}

/** Watches every React Query mutation in the PMA module (any create/update/delete call). */
export function GlobalSavingOverlay() {
  const pending = useIsMutating();
  return <SavingOverlay open={pending > 0} />;
}
